import * as FontAwesome from 'react-icons/fa'
import s from './FontIcon.scss'
import cn from 'classnames'

const FontIcon = ({ icon, classNameProp, className, color = 'gray', size = '0.9em' }) => {
  const FontAwesomeIcon = FontAwesome[icon]

  return (
    <span>
      <FontAwesomeIcon
        className={cn(classNameProp && s[classNameProp], className)}
        color={color}
        size={size}
      />
    </span>
  )
}

export default FontIcon
